const experiments = [

  {
    title: 'Theme Dev Tool',
    description: 'A dynamic theme generator that creates and previews full UI color systems in real time. Users can generate, toggle light/dark modes, and export CSS variables for direct use in projects.',
    tags: ['React', 'CSS Variables', 'Vite', 'JavaScript'],
    link: 'https://themedevstool-hpwi.vercel.app/',
  },
  {
    title: 'Snes UI Lab',
    description: 'A browser-based retro console framework that can load and run cartridge like game desings using a consistent architecture. Ultra realistic SNES shell 3-zone layout(dpad / display / buttons) Cable + lighting Effects Console-grade depth & shading.',
    tags: ['JavaScript', 'CSS', 'HTML'],
    link: 'https://sness-ui-lab.vercel.app/',
  },
    {
    title: 'MouseTrails',
    description: 'Interactive particle trail that follows mouse movement, built with HTML, CSS, and JavaScript.',
    tags: ['JavaScript', 'CSS', 'HTML'],
    link: 'https://codepen.io/RodriguezRamiro/pen/jEPoWwR',
  },
  {
    title: 'JavaScript Blackjack',
    description: 'A classic Blackjack game built with vanilla JavaScript. Features card drawing, score tracking, and dealer logic for realistic gameplay.',
    tags: ['HTML', 'CSS', 'JavaScript'],
    link: 'https://codepen.io/RodriguezRamiro/pen/qEbQXRx',
  },
  {
    title: 'MouseParticles',
    description: 'Particle system where mouse movement attracts or repels particles, with a toggle and physics-based motion.',
    tags: ['JavaScript', 'CSS', 'HTML'],
    link: 'https://codepen.io/RodriguezRamiro/pen/qEdzBYz',
  },
  {
    title: 'Spirals',
    description: 'Color-shifting spiral patterns that follow the mouse using logarithmic geometry and fading trails.',
    tags: ['JavaScript', 'CSS', 'HTML'],
    link: 'https://codepen.io/RodriguezRamiro/pen/Jodzboa',
  },
  {
    title: 'Weather Dashboard',
    description: 'Real-time weather dashboard fetching live data from an external API and displaying dynamic updates.',
    tags: ['HTML', 'CSS', 'JavaScript', 'API'],
    link: 'https://weatherapp-ashy-five.vercel.app/',
  },
  // Do not include Yet Project not finished..
  /*
  {
    title: 'Physics Sim (in progress)',
    description: 'Experimental 2D physics simulation with colliding shapes, gravity, and motion using Matter.js.',
    tags: ['Matter.js'],
    link: '#',
  },
  */
  // Do not include Yet Project not finished..
  /*
  {
    title: 'Memory Game (in progress)',
    description: 'Classic card matching memory game with animated flips and randomized layouts.',
    tags: ['JavaScript', 'CSS', 'HTML'],
    link: '#',
  },
  */
];

export default experiments;
